var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2229 8.35443C25.2229 8.35443 26.5407 14.0956 25.2229 17.8603C23.9053 21.625 20.7996 24.9298 20.7996 24.9298H16.8465C16.8465 24.9298 14.023 12.9661 25.2229 8.35443Z",
    fill: "#AD7E57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8466 24.9298H20.7996C18.6002 18.5269 25.223 8.35443 25.223 8.35443C14.0228 12.9661 16.8466 24.9298 16.8466 24.9298Z",
    fill: "#AD7E57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77701 8.35443C6.77701 8.35443 5.4594 14.0956 6.77701 17.8603C8.09481 21.625 11.2004 24.9298 11.2004 24.9298H15.1536C15.1536 24.9298 17.9774 12.9661 6.77701 8.35443Z",
    fill: "#AD7E57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77539 8.35443C6.77539 8.35443 14.4368 18.5269 11.1988 24.9298H15.152C15.152 24.9298 17.9757 12.9661 6.77539 8.35443Z",
    fill: "#AD7E57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9882 18.7073C20.9882 18.7073 19.859 8.54255 16.0002 3.74249C12.1415 8.54255 11.0118 18.7073 11.0118 18.7073C8.75308 13.9072 0 11.4602 0 11.4602C2.35299 14.8484 5.24938 25.0131 5.24938 25.0131C7.86294 25.0131 24.1306 25.0131 26.7506 25.0131C26.7506 25.0131 29.647 14.8484 32 11.4602C32 11.4602 23.2471 13.9072 20.9882 18.7073Z",
    fill: "#AD7E57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0121 5.17646C15.0121 5.17646 19.1784 6.75665 20.9876 18.7075C20.9876 18.7075 19.8583 8.5428 15.9996 3.74274C15.648 4.17992 15.3192 4.6616 15.0117 5.17606L15.0121 5.17646Z",
    fill: "#AD7E57"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4002 24.1171L2.77534 14.7676C2.23053 14.1771 3.1231 13.3523 3.66831 13.9436C3.68146 13.9578 3.37255 13.5512 11.4002 24.1171Z",
    fill: "#AD7E57"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5039 24.1171L28.5807 14.006C29.0413 13.3479 30.0375 14.0436 29.5764 14.7029C29.5651 14.7191 29.9835 14.2314 21.5039 24.1171Z",
    fill: "#AD7E57"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.8475L15.3931 7.12139C15.3647 6.34393 16.5784 6.30145 16.6069 7.08012C16.6083 7.11916 16.6318 6.41413 16 23.8475Z",
    fill: "#AD7E57"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7504 25.0134C24.1366 25.0134 7.86939 25.0134 5.24915 25.0134C4.38006 25.8825 3.80855 26.3911 2.93945 27.26C2.96494 27.26 29.0334 27.26 29.0601 27.26C28.191 26.3909 27.6193 25.8825 26.7504 25.0134Z",
    fill: "#AD7E57"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3577 3.15927C16.6462 3.90901 15.4621 3.94016 14.7122 3.22886C13.9624 2.51756 13.9315 1.33307 14.6426 0.583336C15.3539 -0.166402 16.5384 -0.197555 17.2879 0.513745C18.0378 1.22504 18.0692 2.40953 17.3577 3.15927Z",
    fill: "#AD7E57"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7524 1.21289C17.3167 2.98386 14.8281 3.14226 14.1832 1.42248C14.0278 2.05407 14.2065 2.74918 14.7122 3.22885C15.4622 3.94015 16.6462 3.90899 17.3577 3.15926C17.8675 2.62214 17.9958 1.86229 17.7524 1.21289Z",
    fill: "#AD7E57"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0732 0.918762C15.8665 0.206855 15.2151 0.886392 14.6543 1.32539C15.3478 0.132204 16.5224 0.239426 17.0732 0.918762Z",
    fill: "#AD7E57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.29f67cd56ce9ec1614edc19ff65ae66c.svg";
export { ForwardRef as ReactComponent };